import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 引入 Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css'
// 引入 Bootstrap JS (可选)
import 'bootstrap/dist/js/bootstrap.min.js'
// 引入 Bootstrap Icons
import 'bootstrap-icons/font/bootstrap-icons.css';

// Bootstrap Vue (可选)
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.config.productionTip = false

// 全局未捕获的 Promise 错误处理
window.addEventListener('unhandledrejection', event => {
  console.error('未处理的 Promise 错误:', event.reason)
  // 阻止浏览器默认的错误处理
  event.preventDefault()
})

// 全局 JavaScript 错误处理
window.addEventListener('error', event => {
  console.error('JavaScript 错误:', event.error)
  // 阻止浏览器默认的错误处理
  event.preventDefault()
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
